import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { Field, FormikProps, getIn } from 'formik';
import { coverageTableStyles } from '../../constants/theme/styles/tables/coverage-table';
import { ContentSpacer } from '../layout/generic-content-spacer';

interface CustomFieldProps {
	name: string;
	label: string | JSX.Element;
	options?: any[];
	disabled?: boolean;
	required?: boolean;
	component: any;
	formProps: FormikProps<any>;

	onChange?: (e) => any;
	onBlur?: (e) => any;
}

export function CustomField(props: CustomFieldProps) {
	const { formProps, name } = props;
	const classes = coverageTableStyles();
	return (
		<div className={classes.coverageTable} data-formdata={props?.name}  >
			{
				formProps?.errors[name] &&
				<ContentSpacer>
					<Banner
						banner={{
							type: 'error',
							label: formProps?.errors[name],
						}}
					/>
				</ContentSpacer>
			}
			<Field
				touched={!!(formProps.touched ? getIn(formProps.touched, name) : '')}
				hasError={!!(formProps.errors ? getIn(formProps.errors, name) : '')}
				{...props}
			/>

		</div>
	);
}

CustomField.defaultProps = {
	onBlur: () => { },
	onChange: () => { },
	options: null,
	disabled: false,
	required: false,
};


